import { c as _c } from "react/compiler-runtime";
import sanitizeHtml from "sanitize-html";
import { cn } from "../../lib/utils";
import styles from "./DangerousText.module.css";
export type DangerousTextServerProps = {
  html: string;
  className?: string;
} & Omit<React.HTMLAttributes<HTMLDivElement>, "dangerouslySetInnerHTML" | "children" | "onClick">;

/**
 * Convert Quill's bullet list format (`<ol><li data-list="bullet">`) into standard `<ul><li>`.
 */
function normalizeQuillLists(input: string): string {
  let result = input.replace(/<span\s+class="ql-ui"[^>]*><\/span>/g, "");
  result = result.replace(/<ol>([\s\S]*?)<\/ol>/g, (_match, inner: string) => {
    const hasBullets = inner.includes('data-list="bullet"');
    if (hasBullets) {
      const cleanedInner = inner.replace(/\s*data-list="[^"]*"/g, "");
      return `<ul>${cleanedInner}</ul>`;
    }
    return `<ol>${inner}</ol>`;
  });
  return result;
}

/**
 * Server-safe version of DangerousText — no event handlers or hooks.
 * Use this in Server Components (e.g. PDF export pages).
 */
export const DangerousTextServer = t0 => {
  const $ = _c(14);
  let className;
  let html;
  let props;
  if ($[0] !== t0) {
    ({
      html,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = html;
    $[3] = props;
  } else {
    className = $[1];
    html = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== html) {
    const normalizedHtml = normalizeQuillLists(html);
    t1 = sanitizeHtml(normalizedHtml, {
      allowedTags: ["p", "br", "strong", "em", "b", "i", "u", "s", "a", "ul", "ol", "li", "blockquote", "div", "span"],
      allowedAttributes: {
        a: ["href", "target", "rel"]
      },
      allowedSchemes: ["http", "https"]
    });
    $[4] = html;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const sanitizedHtml = t1;
  let t2;
  if ($[6] !== className) {
    t2 = cn(styles.dangerousText, "wrap-break-word prose prose-sm max-w-none [&>ol]:my-2 [&>p]:my-2 [&>ul]:my-2", className);
    $[6] = className;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== sanitizedHtml) {
    t3 = {
      __html: sanitizedHtml
    };
    $[8] = sanitizedHtml;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== props || $[11] !== t2 || $[12] !== t3) {
    t4 = <div className={t2} dangerouslySetInnerHTML={t3} {...props} />;
    $[10] = props;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};